<template>
    <div class="signature">
        <canvas
                class="signature__canvas"
                ref="signatureCanvas"
                @mousedown="mousedown"
                @mousemove="mousemove"
                @mouseup="mouseup"
                @touchstart="touchstart"
                @touchmove="touchmove"
                @touchend="touchend"
                :width="width"
                :height="height"
        >
            {{$t('support_canvas')}}
        </canvas>
        <div class="signature__control">
            <div class="signature__clear" @click="clear">x</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Signature",
        props: [
            'width',
            'height',
            'lineWidth',
            'img',
            'signatureChange'
        ],
        data() {
            return {
                canvas: '',
                context: '',
                canvasCoordinats: '',
                mouse: {x: 0, y: 0},
                draw: false,
            }
        },
        created() {
            this.$parent.$on('openDialog', this.initDraw());

            window.addEventListener('scroll', this.handleScroll)
        },
        // mounted() {
        //     this.initDraw();
        // },
        methods: {
            initDraw() {
                let $this = this;
                setTimeout(() => {
                    $this.canvas = $this.$refs.signatureCanvas;
                    $this.context = $this.canvas.getContext("2d");
                    $this.context.lineWidth = $this.lineWidth;
                    if($this.img) {
                        let image = new Image();
                        image.onload = function() {
                            $this.context.drawImage(image, 0, 0);
                        };
                        image.src = $this.img;
                    }
                }, 300)
            },
            mousedown(e) {
                this.mouse.x = e.clientX - this.getCanvasCoordinats().x;
                this.mouse.y = e.clientY - this.getCanvasCoordinats().y;
                this.draw = true;
                this.context.beginPath();
                this.context.moveTo(this.mouse.x, this.mouse.y);
            },
            mousemove(e) {
                if (this.draw === true) {
                    this.mouse.x = e.clientX - this.getCanvasCoordinats().x;
                    this.mouse.y = e.clientY - this.getCanvasCoordinats().y;
                    this.context.lineTo(this.mouse.x, this.mouse.y);
                    this.context.stroke();
                }
            },
            mouseup(e) {
                this.mouse.x = e.clientX - this.getCanvasCoordinats().x;
                this.mouse.y = e.clientY - this.getCanvasCoordinats().y;
                this.context.lineTo(this.mouse.x, this.mouse.y);
                this.context.stroke();
                this.context.closePath();
                this.draw = false;
            },
            touchstart(e) {
                e.preventDefault();
                const touches = e.changedTouches;
                this.draw = true;
                for (let i = 0; i < touches.length; i++) {
                    this.mouse.x = touches[i].clientX - this.getCanvasCoordinats().x;
                    this.mouse.y = touches[i].clientY - this.getCanvasCoordinats().y;
                    this.context.beginPath();
                    this.context.moveTo(this.mouse.x, this.mouse.y);
                }
            },
            touchmove(e) {
                e.preventDefault();
                const touches = e.changedTouches;
                for (let i = 0; i < touches.length; i++) {
                    this.mouse.x = touches[i].clientX - this.getCanvasCoordinats().x;
                    this.mouse.y = touches[i].clientY - this.getCanvasCoordinats().y;
                    this.context.lineTo(this.mouse.x, this.mouse.y);
                    this.context.stroke();
                }
            },
            touchend(e) {
                e.preventDefault();
                const touches = e.changedTouches;
                for (let i = 0; i < touches.length; i++) {
                    this.mouse.x = touches[i].clientX - this.getCanvasCoordinats().x;
                    this.mouse.y = touches[i].clientY - this.getCanvasCoordinats().y;
                    this.context.lineTo(this.mouse.x, this.mouse.y);
                    this.context.stroke();
                    this.context.closePath();
                }
                this.draw = false;
            },
            getCanvasCoordinats() {
                return this.canvas.getBoundingClientRect();
            },
            clear() {
                if(this.context !== '') {
                    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
                }
            },
            sendSignature() {
                this.signatureChange(this.canvas.toDataURL())
            },

        }
    }
</script>